import { render, staticRenderFns } from "./buttomBox.vue?vue&type=template&id=409d957c&scoped=true"
import script from "./buttomBox.vue?vue&type=script&lang=js"
export * from "./buttomBox.vue?vue&type=script&lang=js"
import style0 from "./buttomBox.vue?vue&type=style&index=0&id=409d957c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409d957c",
  null
  
)

export default component.exports